import firebase from 'firebase/app';
// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import {getCompanySettings, getSageIntegrationDetails, watchForIntegrationChanges} from '@/router/views/production/helper/dbHelpers.js';
// import mutations from 'state/modules/auth.js';

class FirebaseAuthBackend {
    constructor(firebaseConfig) {
        if (firebaseConfig) {
            // Initialize Firebase
            firebase.initializeApp(firebaseConfig);
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    sessionStorage.setItem("authUser", JSON.stringify(user));
                } else {
                    sessionStorage.removeItem('authUser');
                }
            });
        }
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
                // eslint-disable-next-line no-redeclare
                var user = firebase.auth().currentUser;
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * forget Password user with given details
     */
    forgetPassword = (email) => {
        return new Promise((resolve, reject) => {
            firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + "//" + window.location.host + "/login" }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    setLoggeedInUser = (user) => {
        sessionStorage.setItem("authUser", JSON.stringify(user));
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = async () => {
        if (!sessionStorage.getItem('authUser')){
            return null;
        }else{
            //get the company name from the database as well.
            await firebase.firestore().collection('employees')
                                        .where('auth', '==', JSON.parse(sessionStorage.getItem('authUser')).uid)
                                        .get()
                .then(querySnapshot=>{
                    if(!querySnapshot.empty){
                        querySnapshot.forEach(user=>{
                            sessionStorage.setItem('org', user.data().org);
                        });
                        //set the integratio details waitcher.
                        watchForIntegrationChanges();
                    }
                }).catch(err=>{
                    console.log(`Error getting user data: ${err}`)
                });
            //get the sage integration details, if there are any.
            getSageIntegrationDetails();
            getCompanySettings();
            return JSON.parse(sessionStorage.getItem('authUser'));
        }
    }

    //this function accepts a user and retrieves the auth level from the database.
    async getAuthenticatedUsersAdminLevel(user) {
        if (!user) {
          return null;
        } else {
          //get the company name from the database as well.
          let userLevels = [];
          await firebase
            .firestore()
            .collection('employees')
            .where('auth', '==', user.uid)
            .get()
            .then((querySnapshot) => {
              if (!querySnapshot.empty) {
                querySnapshot.forEach((user) => {
                  userLevels = user.data().position;
                });
              }
            })
            .catch((err) => {
              console.log(`Error getting user data: ${err}`);
            });
        
            return userLevels;
        }
      }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        var errorMessage = error.message;
        return errorMessage;
    }
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config 
 */
const initFirebaseBackend = (config) => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend(config);
    }
    return _fireBaseBackend;
}

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
    return _fireBaseBackend;
}

export { initFirebaseBackend, getFirebaseBackend };